import React from 'react';

const MapFailure = () => (
  <div className="map-box d-flex align-items-center justify-content-center">
    <h1>Failure</h1>
  </div>
);

export { MapFailure };
